import { render } from "./ManageJobProfilesList.vue?vue&type=template&id=5370b008&scoped=true"
import script from "./ManageJobProfilesList.vue?vue&type=script&lang=js"
export * from "./ManageJobProfilesList.vue?vue&type=script&lang=js"

import "./ManageJobProfilesList.vue?vue&type=style&index=0&id=5370b008&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5370b008"]])

export default __exports__